import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';
import Carousel from './components/Carousel/Carousel.js';

const modules = [
  {
    intlKey: '1',
    name: 'Queremos que nossos clientes nos amem fanaticamente',
    txt: 'Colocamos os clientes em primeiro lugar, construindo os melhores produtos e experiências excepcionais',
  },
  {
    intlKey: '2',
    name: 'Somos pessoas ávidas e desafiamos o status quo',
    txt: 'Temos mentalidade de constante melhoria e inovação nos mantendo adaptáveis e com visão de futuro, garantindo a nossa relevância num mercado dinâmico e desafiador',
  },
  {
    intlKey: '3',
    name: 'Pensamos e agimos com senso de propriedade, não como quem aluga',
    txt: 'Cultivamos o senso de responsabilidade e prestação de contas, alinhando-nos como uma equipe unida e com um propósito compartilhado, sempre agindo como donos do Nubank',
  },
  {
    intlKey: '4',
    name: 'Construímos equipes fortes e diversas',
    txt: 'A diversidade aumenta a nossa criatividade e capacidade de resolução de problemas, tornando-nos mais fortes à medida que trabalhamos juntos para alcançar o nosso melhor',
  },
  {
    intlKey: '5',
    name: 'Buscamos eficiência inteligente',
    txt: 'Otimizamos nossos esforços e recursos, aproximando-nos de nossos objetivos com maior precisão quando focamos em eficiência',
  }
];

class SectionBootcampModules extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (

      <Box
        gridColumn={{ lg: '2 / 12' }}
        maxWidth={{ md: '700px', lg: '700px' }}
        marginHorizontal={{ md: 'auto' }}
        justify='left'
        alignItems='left'
      >

        <Block
          paddingTop="10x"
          blockWidth="100%" textAlign="center" justifyContent="center"
        >

          <Carousel
            textAlign='center'
            currentStep={currentStep}
            onStepChanged={this.handleChangeCarouselStep}
          // textAlign="center" justifyContent="center"
          >
            {modules.map(module => (
              <div key={module.intlKey}>
                <Typography
                  variant="heading4" strong
                  color="primary"
                  textAlign="center"
                  gutterBottom={1}
                  justifyContent="center">
                  {module.name}
                </Typography>
                <Typography
                  variant="subtitle2"
                  // tag="p"
                  // gutterBottom={1}
                  textAlign="center" justifyContent="center"
                >
                  {module.txt}
                </Typography>
              </div>
            ))}
          </Carousel>

        </Block>
      </Box>

    );
  }
}

export default SectionBootcampModules;
